import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslations } from "use-intl";

interface TabsNavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  hidden?: boolean;
}

const TabsNavigation: React.FC<TabsNavigationProps> = ({ activeTab, setActiveTab, hidden }) => {
  const t = useTranslations("consultantPayables.status");
  if (hidden) return null;
  return (
    <TabsList className="w-full justify-start mb-4">
      <TabsTrigger value="all">{t("all")}</TabsTrigger>
      <TabsTrigger value="unpaid">{t("unpaid")}</TabsTrigger>
      <TabsTrigger value="pending">{t("pending")}</TabsTrigger>
      <TabsTrigger value="paid">{t("paid")}</TabsTrigger>
      <TabsTrigger value="manually_handled">{t("manually_handled")}</TabsTrigger>
      <TabsTrigger value="overdue">{t("overdue")}</TabsTrigger>
    </TabsList>
  );
};

export default TabsNavigation;
